import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Grid, Typography, InputAdornment, IconButton } from "@mui/material";

import { TextField } from "../../../components";
import { colors } from "../../css components/Style";
import Logo from "../../../assets/grow_logo-removebg-preview.png";
import { PrimaryLoadingButton } from "../../css components/Button";

export default function FormDisplay({ formikProps }) {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);

  return (
    <Fragment>
      <Grid container spacing={2} className="login-grid">
        <Grid size={12}>
          <Typography
            className="form-title"
            style={{ color: colors.growthOSDarkBlue }}
          >
            CONNECTED ID
          </Typography>{" "}
        </Grid>

        <Grid size={6}>
          <TextField
            label="First Name"
            required
            name="givenName"
            formikProps={formikProps}
            placeholder="First Name"
          />
        </Grid>

        <Grid size={6}>
          <TextField
            required
            label="Last Name"
            name="familyName"
            placeholder="Last Name"
            formikProps={formikProps}
          />
        </Grid>

        <div style={{ marginBottom: "10px" }} />

        <Grid size={12}>
          <TextField
            required
            label="Display Name"
            name="displayName"
            placeholder="Display Name"
            formikProps={formikProps}
          />
        </Grid>

        <div style={{ marginBottom: "10px" }} />

        <Grid size={12}>
          <TextField
            required
            label="Email Address"
            name="email"
            placeholder="Email Address"
            formikProps={formikProps}
          />
        </Grid>

        <div style={{ marginBottom: "10px" }} />

        <Grid size={12}>
          <TextField
            required
            type={showPassword ? "text" : "password"}
            name="password"
            label="Password"
            placeholder="Password"
            formikProps={formikProps}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {!showPassword && <VisibilityOff />}
                    {showPassword && <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <div style={{ marginBottom: "10px" }} />

        <Grid size={12}>
          <TextField
            required
            type={confirmPassword ? "text" : "password"}
            name="confirmPassword"
            label="Confirm password"
            placeholder="Confirm password"
            formikProps={formikProps}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => setConfirmPassword(!confirmPassword)}
                  >
                    {!confirmPassword && <VisibilityOff />}
                    {confirmPassword && <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <div style={{ marginBottom: "10px" }} />

        <Grid size={12}>
          <PrimaryLoadingButton
            type="submit"
            variant="contained"
            fullWidth
            onClick={formikProps.handleSubmit}
            disabled={!formikProps.dirty || !formikProps.isValid}
            loading={formikProps.isSubmitting}
          >
            Sign Up
          </PrimaryLoadingButton>
        </Grid>

        <Grid size={12} className="form-links">
          <Typography className="signup-link" variant="caption1">
            Already have an account?{" "}
            <Typography
              variant="button"
              style={{
                cursor: "pointer",
                fontWeight: 500,
                color: colors.growthOSDarkBlue,
              }}
              onClick={() => navigate("/sign-in")}
            >
              Sign In!
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      <div className="footer-branding">
        <span>Powered by</span>
        <div className="growth-os-logo">
          <img
            src={Logo}
            alt="1"
            style={{ height: "25px", position: "relative", top: "-3px" }}
          />
        </div>
      </div>
    </Fragment>
  );
}
